export default "__VITE_PUBLIC_ASSET__5779fe9a__"